import React from 'react'

function ShowNetDeals() {
  return (
    <div>ShowNetDeals</div>
  )
}

export default ShowNetDeals